import { setGetListDictionaryAction } from '../action';
import { getDictionary } from '../api/getDictionary';

export const setGetDictionary = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getDictionary(params);
            
            if (data.status === 'success') {
                dispatch(setGetListDictionaryAction({
                    list: data.data,
                    countPage: data.countPage
                }))
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}